import { Employee } from '~/types';
import axios, { ResponseType } from './axios';

export const getEmployees = (params: Record<string, any>): ResponseType<Employee[]> => {
  const { authority, ...restParams } = params;
  if (authority === 'owner') restParams.owner = true;
  if (authority === 'executive') restParams.executive = true;
  return axios.get('/employees', { params: restParams });
};

export const getAllEmployees = (): ResponseType<Employee[]> => {
  return axios.get('/employees', { params: { page: 1, perPage: 9999 } });
};

export const updateEmployee = ({
  id,
  body,
}: {
  id: string;
  body: Employee & { accessCode?: string };
}): ResponseType<Employee> => {
  // make sure we don't save access code
  const { accessCode, ...rest } = body;
  return axios.put(`/employees/${id}`, rest);
};

export const createEmployee = (body: Employee): ResponseType<Employee> => {
  const { roles = [], ...rest } = body;
  return axios.post(`/employees`, { roles, ...rest });
};

export const getEmployeeAccessCode = ({
  id,
  phone,
}: {
  id: string;
  phone?: string;
}): ResponseType<Employee & { accessCode: string }> => {
  return axios.post(`/employees/${id}/accessCode`, {
    phone,
  });
};

export const deleteEmployee = (id: string): ResponseType<any> => {
  return axios.delete(`/employees/${id}`);
};

export const getEmployeeById = (id: string) => (): ResponseType<Employee> => {
  return axios.get(`/employees/${id}`);
};

export const getEmployeeRoles = () => {
  return axios
    .get<{ role: string; name: string }[]>(`/employees/roles`)
    .then((result) => result.data);
};
